var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUaeFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 496 496",
    xmlSpace: "preserve",
    width: "64px",
    height: "64px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 1.984
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C4B4B"
    },
    d: "M0,304v65.6C0,396.8,21.6,416,48,416h400c26.4,0,48-19.2,48-46.4V304H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49A948"
    },
    d: "M448,80H48C21.6,80,0,99.2,0,126.4V192h496v-65.6C496,99.2,474.4,80,448,80z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 192,
    style: {
      fill: "#FFFFFF"
    },
    width: 496,
    height: 112
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F3F3F"
    },
    d: "M446.4,416c26.4,0,49.6-19.2,49.6-46.4V304H315.2L446.4,416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#369933"
    },
    d: "M448,80H48l132.8,112H496v-65.6C496,99.2,474.4,80,448,80z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CFE5E2"
    },
    points: "316,304 496,304 496,192 180,192 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C8417"
    },
    d: "M448,80H48l370.4,112H496v-65.6C496,99.2,474.4,80,448,80z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BAD3CF"
    },
    points: "496,214.4 496,192 414.4,192 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232222"
    },
    d: "M496,368.8c0,28.8-21.6,47.2-48,47.2H48c-26.4,0-48-20.8-48-48"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E73B36"
    },
    d: "M120,80H48C21.6,80,0,99.2,0,126.4v64v0.8v114.4v0.8v64C0,396.8,21.6,416,48,416h72V80z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DB2C2C"
    },
    points: "120,192 0,192 0,191.2 0,304.8 0,304 120,304 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC2525"
    },
    d: "M0,304v2.4v64C0,396.8,21.6,416,48,416h72V304H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B70808"
    },
    d: "M0,368c0,32,21.6,48,48,48h72v-48H0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CC2525"
    },
    points: "120,80 48,80 120,140.8 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B70808"
    },
    points: "120,80 48,80 120,100 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUaeFlag);
export default __webpack_public_path__ + "static/media/UAE_Flag.847851744847e10220881205376d3282.svg";
export { ForwardRef as ReactComponent };